const isEnabled = () => {
  if (import.meta.env.DEV) return false;
  return import.meta.env.DISABLE_VITE_ANTI_DEVTOOLS_REFRESH !== 'true';
};

const RELOAD_COOLDOWN_MS = 5000;
const DEVTOOLS_DELTA_THRESHOLD = 160;

const forceRefresh = () => {
  const key = 'antiDevtoolsLastReload';
  const last = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
  sessionStorage.setItem(key, String(Date.now()));
  window.location.reload();
};

/**
 * DevTools 侧栏/底栏会显著增大 outer 与 inner 的差值；浏览器顶栏也会带来固定差值。
 * 以页面加载时的差值为基线，只在差值相对基线突然增大时判定为 DevTools 打开。
 */
const createDimensionDetector = (threshold: number) => {
  const baseline = {
    widthGap: window.outerWidth - window.innerWidth,
    heightGap: window.outerHeight - window.innerHeight,
  };

  return () => {
    const widthGap = window.outerWidth - window.innerWidth;
    const heightGap = window.outerHeight - window.innerHeight;
    return (
      widthGap - baseline.widthGap > threshold ||
      heightGap - baseline.heightGap > threshold
    );
  };
};

const isDevtoolsShortcut = (e: KeyboardEvent) => {
  const key = e.key?.toUpperCase();
  if (key === 'F12') return true;
  if (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(key)) return true;
  if (e.ctrlKey && key === 'U') return true;
  if (e.metaKey && e.altKey && ['I', 'J', 'C'].includes(key)) return true;
  return false;
};

export const initAntiDevtools = () => {
  if (!isEnabled()) return;

  const INTERVAL_MS = 1000;
  const checkDevtoolsByDimensions = createDimensionDetector(DEVTOOLS_DELTA_THRESHOLD);

  const detect = () => {
    if (checkDevtoolsByDimensions()) {
      forceRefresh();
    }
  };

  detect();
  window.addEventListener('resize', detect);
  document.addEventListener('keydown', (e) => {
    if (isDevtoolsShortcut(e)) {
      e.preventDefault();
      forceRefresh();
    }
  });
  window.setInterval(detect, INTERVAL_MS);
};
